import React from 'react';

import PropTypes from 'prop-types';

export const cleanCheck = ({ fillColor }) => (
    <svg viewBox='0 0 26 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g fill={fillColor}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M1 9.95673L3.4 7.63462L9.57143 13.6058L22.6 1L25 3.32212L9.57143 18.25L1 9.95673Z'
            />
        </g>
    </svg>
);

cleanCheck.propTypes = {
    fillColor: PropTypes.string.isRequired
};

export default cleanCheck;
